import SoftBadge from "components/SoftBadge";

const colors = {
  error: "error",
  warning: "warning",
  info: "info",
  success: "success",
  customInfo: "customInfo",
  // schedule Event status colors
  recurring: "recurring",
  executing: "executing",
  canceling: "canceling",
  completed: "completed",
  paused: "paused",
};

const colorByStatus = {
  deleted: colors.error,
  draft: colors.customInfo,
  "Test Mode": colors.customInfo,
  invited: colors.warning,
  active: colors.success,
  "For Approval": colors.warning,
  suspended: colors.error,
  Declined: colors.error,
  Published: colors.success,
  Upgrade: colors.success,
  recurring: colors.recurring,
  executing: colors.executing,
  canceling: colors.canceling,
  completed: colors.completed,
  failed: colors.error,
  paused: colors.paused,
};

const StatusBadge = ({ status }) => {
  if (!status) return null;

  if (status === "ForApproval") {
    status = "For Approval";
  } else if (status === "test") {
    status = "draft";
  }

  return (
    <SoftBadge
      variant="contained"
      size="xs"
      color={colorByStatus[status] || "success"}
      container
      badgeContent={status}
    />
  );
};

export default StatusBadge;
